<template>
  <SearchableModel
    model-name="Tour"
    sort="start_at"
    without-limit-change
    autofocus-search
  >
    <template #default="{ models }">
      <div class="tw:rounded-lg tw:border tw:border-zinc-200 tw:overflow-hidden tw:bg-white">
        <table class="tw:w-full">
          <tbody class="tw:divide-y tw:divide-zinc-200">
            <tr v-for="tour in models" :key="tour.id" class="tw:align-top tw:md:align-middle">
              <td class="tw:px-5 tw:py-5 tw:md:py-3 tw:flex-1">
                <TourInformation :tour="tour" />
              </td>
              <td class="tw:px-5 tw:py-5 tw:md:py-3 tw:text-right tw:whitespace-nowrap">
                <form :action="installUrl" method="POST">
                  <input type="hidden" name="_token" :value="csrfToken">
                  <input type="hidden" name="tour_id" :value="tour.id">
                  <Button type="submit" size="sm">
                    {{ $t('Install') }}
                  </Button>
                </form>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </SearchableModel>
</template>

<script setup>
import SearchableModel from '@/components/searchable-model/SearchableModel.vue'
import TourInformation from '@/components/Tour/TourInformation.vue'
import { Button } from '@/shadcn/components/ui/button'

defineProps({
  installUrl: {
    type: String,
    required: true,
  },
})

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
</script>
